export default class PictoList {
  constructor(el) {
    this.el = el
    this.init()
  }

  init() {}
}
